<template>
  <div class="t-modal-heading">
    <div
      v-if="kind"
      class="shrink-0 flex items-center justify-center h-12 w-12 mb-3 rounded-full"
      :class="[kindsClasses[kind], { 'mx-auto': !left }]"
    >
      <UIcon :name="kindsIcons[kind]" class="w-7 h-7" aria-hidden="true" />
    </div>

    <div :class="{ 'text-center': !left }">
      <TText
        v-if="$slots.title"
        size="lg"
        tag="div"
        variant="semibold"
        color="gray900"
        classes="mb-2"
      >
        <slot name="title" />
      </TText>

      <TText
        v-if="$slots.subtitle"
        variant="semibold"
        size="lg"
        tag="div"
        color="gray600"
        classes="mb-2"
      >
        <slot name="subtitle" />
      </TText>

      <TText
        v-if="$slots.body"
        size="base"
        tag="div"
        color="gray600"
        classes="mb-0"
      >
        <slot name="body" />
      </TText>
    </div>
  </div>
</template>

<script setup lang="ts">
export type TModalHeadingKinds = 'blue' | 'green' | 'yellow' | 'red' | false

const kindsClasses = {
  blue: 'bg-blue-100 text-blue-600',
  green: 'bg-green-100 text-green-600',
  yellow: 'bg-yellow-100 text-yellow-600',
  red: 'bg-red-100 text-red-600',
}

const kindsIcons = {
  blue: 'i-heroicons-information-circle',
  green: 'i-heroicons-check-circle',
  yellow: 'i-heroicons-exclamation-triangle',
  red: 'i-heroicons-x-circle',
}

interface propsInterface {
  kind: TModalHeadingKinds
  left?: boolean
}

withDefaults(defineProps<propsInterface>(), {
  kind: false,
  left: false,
})
</script>
